import PropTypes from "prop-types";
import { useSelector } from 'react-redux';

/** Components */
import UnauthorizedPage from '../pages/unauthorizedPage/UnauthorizedPage';
import { hasPermission } from '../utils/authentication/authorizeNavigation';

const AuthorizedRoute = ({ component: Component, securityKey }) => {
    const { isLoggedIn, isAuthenticated } = useSelector((state) => state.auth);

    if (isLoggedIn && isAuthenticated) {
        if (!securityKey || hasPermission(securityKey)) {
            return <Component />;
        }
        return <UnauthorizedPage />;
    }

    return <UnauthorizedPage />;
};

export default AuthorizedRoute;

AuthorizedRoute.propTypes = {
    component: PropTypes.elementType.isRequired,
    securityKey: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string),
    ]),
};